<mat-table [dataSource]="drugs" style="height:100%;">
    <ng-container matColumnDef="entry">
      <mat-cell *matCellDef="let element; let index = index">
          <app-drug-entry (selected)="selectDrugPackage($event)" [drug]="element" style="width:100%;"></app-drug-entry>
      </mat-cell>
    </ng-container>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>